<div *ngIf="index">

  <app-table-tickets *ngIf="!loading" [dataTable]="tableData" (out)="action($event)"></app-table-tickets>

</div>

<app-loading *ngIf="loading"></app-loading>


<div *ngIf="!index && recibiendo">

  <hr>
  <h3 [hidden]="recibiendoItems.length === 0"> <b> Deliver Items </b> </h3> <br>

  <!--<div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label for="glblocation">Global location</label>
                <select name="glblocation" id="glblocation" #glblocation="ngModel" [(ngModel)]="globalLocation" class="form-control" (change)="selectAll()">
                    <option *ngFor="let location of askdpts" [value]='location.id'>{{location.locationName}}</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
         
              <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll(true)">
                <i class="material-icons">{{aplicarTodos ? 'check_box' : 'check_box_outline_blank'}}</i>
              </a> <label (click)="selectAll(true)" style="cursor: pointer" class="primary">Apply to All</label>
            </div>
          </div>-->

  <div class="material-datatables" [hidden]="recibiendoItems.length === 0">
    <table id="receiveItems" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
      style="width:100%">

      <thead>
        <tr>
          <!-- <th class="disabled-sorting">
                   <b> 
                     <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
                       <i class="material-icons">{{checkAll() ? 'check_box' : 'check_box_outline_blank'}}</i>
                     </a> 
                     </b> 
                   </th> -->
          <th> <b> Id </b> </th>
          <th> <b> Item Type </b> </th>
          <th> <b> Net Weight </b> </th>
          <th> <b> Damage </b> </th>
          <th> <b> Date Received </b> </th>
          <th> <b> Location </b> </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of recibiendoItems">
          <!-- <td>
                    <a class="btn btn-link btn-info btn-just-icon" (click)="selectItem(item.id)">
                      <i class="material-icons">{{check(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
                    </a>
                  </td> -->
          <td>{{item.id}}</td>
          <td>{{item.item}}</td>
          <td>{{item.weight}} Lbs</td>
          <td>{{item.damages}}</td>
          <td>{{item.createdAt | date : 'MM-dd-yyyy'}}</td>
          <td>
            <select-filter id="selectLocation{{item.id}}" plholder="Locations" type="location"
              [options]="item.availableLocations"
              (changeOption)="cambiar($event, item)"></select-filter>
          </td>
        </tr>
      </tbody>

    </table>
  </div>


  <h3 [hidden]="recibiendoManifest.length === 0">
            <b> Deliver Batch Items </b>
          </h3>

          <div
            class="material-datatables"
            [hidden]="recibiendoManifest.length === 0"
          >
            <table
              id="receiveItemsManifest"
              class="table table-striped table-no-bordered table-hover"
              cellspacing="0"
              width="100%"
              style="width: 100%"
            >
              <thead>
                <tr>
                  <!-- <th class="disabled-sorting">
                   <b>
                     <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
                       <i class="material-icons">{{checkAll() ? 'check_box' : 'check_box_outline_blank'}}</i>
                     </a>
                     </b>
                   </th> -->
                  <th><b> Id </b></th>
                  <th><b> Container Type</b></th>
                  <th><b> Net Weight </b></th>
                  <th><b> Type of Content </b></th>
                  <th><b> Date Received </b></th>
                  <th><b> Location </b></th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of recibiendoManifest; let i = index">
                  <!-- <td>
                    <a class="btn btn-link btn-info btn-just-icon" (click)="selectItem(item.id)">
                      <i class="material-icons">{{check(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
                    </a>
                  </td> -->
                  <td>{{ item.id }}</td>
                  <td>{{ item.containerType }}</td>
                  <td>{{ item.weight }} Lbs</td>
                  <td>{{ item.typeOfContent }}</td>
                  <td>{{ item.createdAt.timestamp * 1000 | date: "MM-dd-yyyy" }}</td>
                  <td>
                     <select-filter id="selectManifestLocation{{item.id}}" plholder="Locations" type="location"
              [options]="item.availableLocations"
              (changeOption)="cambiar($event, item)"></select-filter>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

  <h3 [hidden]="recibiendoScraps.length === 0"> <b> Deliver Scraps </b> </h3> <br>

  <div class="material-datatables" [hidden]="recibiendoScraps.length === 0">
    <table id="receiveScraps" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%"
      style="width:100%">

      <thead>
        <tr>
          <!-- <th class="disabled-sorting">
                   <b> 
                     <a class="btn btn-link btn-primary btn-just-icon" (click)="selectAll()">
                       <i class="material-icons">{{checkAll() ? 'check_box' : 'check_box_outline_blank'}}</i>
                     </a> 
                     </b> 
                   </th> -->
          <th> <b> Id </b> </th>
          <th> <b>Accumulation Start Date</b> </th>
          <th> <b> Category </b> </th>
          <th> <b> Tare Weight </b> </th>
          <th> <b> Last update </b> </th>
          <th> <b> Location </b> </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of recibiendoScraps">
          <!-- <td>
                    <a class="btn btn-link btn-info btn-just-icon" (click)="selectItem(item.id)">
                      <i class="material-icons">{{check(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
                    </a>
                  </td> -->
          <td>{{item.id}}</td>
          <td>{{item.fechaCreado.timestamp * 1000 | date: 'MM/dd/yyyy'}}</td>
          <td>{{item.categoryId.name}}</td>
          <td>{{item.tareWeight}}</td>
          <td *ngIf="item.fechaModificado !== null">{{item.fechaModificado.timestamp * 1000 | date: 'MM/dd/yyyy'}}</td>
          <td *ngIf="item.fechaModificado === null"></td>
          <td>
            <select-filter id="selectLocation{{item.id}}" plholder="Locations" type="location"
              [options]="item.availableLocations"
              (changeOption)="cambiar($event, item)"></select-filter>
          </td>
        </tr>
      </tbody>

    </table>
  </div>

  <!-- <div class="row">
    <div class="col-md-12">
      <div class="alert alert-info" role="alert">
        <i style="color: blanchedalmond;" class="fa fa-info-circle" aria-hidden="true"></i> Only items with "Pending" status will be received
      </div>
    </div>
  </div>-->

  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-default btn-md" (click)="cancelarRecibir()">
        <i class="fa fa-reply" aria-hidden="true"></i> Cancel
      </button>
    </div>
    <div class="col-md-6" style="text-align: right;">
      <button class="btn btn-primary btn-md" (click)="saveRecibir()" [disabled]="saving || !nolocation()">
        <i *ngIf="!saving" class="fa fa-paper-plane" aria-hidden="true"></i>
        <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
        Delivered
      </button>
    </div>
  </div>

</div>

<div *ngIf="!index && !recibiendo">
  <h3 *ngIf="ticket.id !== null"> <b>Requested by:</b> {{requesetdBy}}</h3>
  <h3 *ngIf="ticket.id !== null">
    {{ticket.id === null ? 'Create a new Ticket': 'View Ticket'}}# {{this.ticket.id}}
  </h3>
  <div class="alert alert-danger" *ngIf="showWarehouseError" role="alert">
 You dont't have a default warehouse location, please <a href="/pages/editprofile/1">click here</a> and choose one.
    </div>
  <h4 *ngIf="ticket.id !== null"><b>Status:</b>
    <b *ngIf="ticket.status === 'pending'" style="color: #D68910"> Pending</b>
    <b *ngIf="ticket.status === 'received'" style="color: #3498DB"> Delivered</b>
    <b *ngIf="ticket.status === 'COMPLETED'" style="color:#239B56"> Completed</b>
  </h4>
  <h3 *ngIf="ticket.id === null">
    Create a new Ticket
  </h3>
  <form #f='ngForm'>

    <div class="grid-container">
            <div class="form-group">
              <label for="type">Type</label>
              <select name="type" id="type" #type="ngModel" [(ngModel)]="ticket.type" class="form-control"
                [disabled]="!edit">
                <option value='in'>In</option>
                <option value='out'>Out</option>
              </select>
            </div>
            <div class="form-group">
              <label for="dline">Deadline</label>
              <select name="dline" id="dline" #dline="ngModel" [(ngModel)]="deadline" (change)="changeDeadline()"
                class="form-control" [disabled]="!edit">
                <option value='ASAP'>ASAP</option>
                <option value='Today no rush'>Today no rush</option>
                <option value='Tomorrow'>Tomorrow</option>
                <option value='Custom'>Custom</option>
              </select>
            </div>
            <div *ngIf="deadline === 'Custom'" class="form-group">
              <label for="dateDeadLine">Date</label>
              <input type="date" name="dateDeadLine" id="dateDeadLine" #dateDeadLine="ngModel"
                [(ngModel)]="ticket.deadline" class="form-control" [disabled]="!edit">
            </div>
            <div class="form-group">
              <label for="askto">Destination</label>
              <select name="askto" id="askto" #askto="ngModel" [(ngModel)]="ticket.askedLocation" class="form-control"
                [disabled]="!edit">
                <option *ngFor="let location of askdpts" [value]='location.id'>{{location.location.name}} - {{location.locationName}}</option>
              </select>
            </div>
          </div>
          <div class="grid-container">
            <div class="form-group">
              <label class="bmd-label-floating">Comments:</label>
              <div class="form-group">
                <textarea name="comments" #comments="ngModel" [(ngModel)]="ticket.comments" class="form-control"
                  [readOnly]="!edit"></textarea>
              </div>
            </div>
          </div>
    <div *ngIf="edit">
      <br>
      <h3> Assign Ticket To </h3>
    </div>

    <div class="" *ngIf="edit">
      <div class="">
        <mat-radio-group name="sendTo" [(ngModel)]="to" aria-label="Select an option" (change)="reset()">
          <mat-radio-button value="USERS">Users</mat-radio-button> &nbsp;&nbsp;
          <mat-radio-button value="GROUPS">Groups</mat-radio-button> &nbsp;&nbsp;
          <mat-radio-button value="TAGGINGGROUPS">Tagging Groups</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <div class="" *ngIf="edit">
      <div class="">
        <form>
          <input type="search" class="form-control margen" name="buscarItem" [(ngModel)]="searchItem" placeholder="Add" (keypress.enter)="false">
        </form>
        <section class="scroll">
          <div *ngFor="let item of toppingList" class="row notify">
            <div class="" *ngIf="buscarItem(item.name, item.surname)">
              <div class="" (click)="seleccionar(item.id)">

                <div class="">
                  <a class="btn btn-link btn-primary btn-just-icon">
                    <i class="material-icons">{{chequeado(item.id) ? 'check_box' : 'check_box_outline_blank'}}</i>
                  </a>
                  <span>{{item.name | titlecase }} {{item.surname}}</span>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="col-4">
        <br>
        <section class="scroll">
          <div *ngFor="let item of toppingList" class="row notify">
            <div class="col-12" *ngIf="chequeado(item.id)">
              <div class="row">

                <div class="col-12">
                  <a class="btn btn-link btn-danger btn-just-icon" (click)="seleccionar(item.id)">
                    <i class="material-icons">close</i>
                  </a>
                  <span>{{item.name}} {{item.surname}}</span>
                </div>

              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- <div class="row" *ngIf="edit">
      <div class="col-12">
        <mat-form-field class="example-full-width">
          <mat-label>Message</mat-label>
          <textarea name="msge" [(ngModel)]="mensaje" maxlength="100" rows="3" matInput required></textarea>
        </mat-form-field>
      </div>
    </div> -->

    <div *ngIf="!viendoComentarios">

      <div class="row" *ngIf="ticket.id === null">
        <div class="col-md-12" style="text-align: right;">
          <mat-checkbox color="primary" [checked]="hideprocessed === 1" (change)="ocultarProcesados($event)">
            <strong style="color: blue;">Hide Processed Containers</strong>
          </mat-checkbox>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <br>
          <h3> <b> {{ticket.id === null ? 'Add Containers': 'Containers'}} </b> </h3> <br>
        </div>
      </div>

      <div *ngIf="!edit" style="text-align: center;" class="row">
        <div class="col-md-12">

          <button class="btn btn-success btn-md" (click)="recibir()" [disabled]="checkPending()">
            Deliver
          </button>

          <!-- &nbsp; &nbsp;
  
            <button class="btn btn-info btn-md" (click)="procesar()" [disabled]="checkReceived()">
              Mark as Processed
            </button> -->

        </div>
      </div>
      <app-loading *ngIf="loadingItems || loadingScraps"></app-loading>
      <div class="row" *ngIf="!loadingItems && items.length > 0">
        <div class="col-md-12">

          <app-table-items *ngIf="!loadingItems" [askedLocation]='ticket.askedLocation' [data]="items" [status]="ticket.id !== null" [bulk]="bulkItems" [ticketStatus]="ticket.status" (change)="bulkItems = $event" (verComentarios)="viewItemComments($event)">
          </app-table-items>

        </div>
      </div>



      <div *ngIf="itemsManifest.length > 0" class="row">
        <div class="col-md-12">
          <br>
          <h3> <b> {{ticket.id === null ? 'Add Batch Containers': 'Batch Containers'}} </b> </h3> <br>
        </div>
      </div>

      <div class="row" *ngIf="!loadingItems && itemsManifest.length > 0">
        <div class="col-md-12">

          <app-table-manifest-items *ngIf="!loadingItems" [askedLocation]='ticket.askedLocation' [data]="itemsManifest" [status]="ticket.id !== null" [bulk]="bulkItemsManifest"
            (change)="bulkItemsManifest = $event" (verComentarios)="viewManifestItemComments($event)">
          </app-table-manifest-items>

        </div>
      </div>

      <div *ngIf="scraps.length > 0" class="row">
        <div class="col-md-12">
          <h3> <b> {{ticket.id === null ? 'Add Scraps': 'Scraps'}} </b> </h3> <br>
        </div>
      </div>

      <div *ngIf="!loadingScraps && scraps.length > 0" class="row">
        <div class="col-md-12">
          <app-table-scraps  *ngIf="!loadingScraps" [data]="scraps" [status]="ticket.id !== null" [bulk]="bulkScraps"
            (change)="bulkScraps = $event" (verComentarios)="viewItemComments($event)">
          </app-table-scraps>
        </div>
      </div>

      <div *ngIf="whs_id == 0" class="row">
        <div class="col-md-12">
          <div class="alert alert-warning" role="alert">
            you must set a default warehouse location. Please, go to profile and choose one.
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <button class="btn btn-default btn-md" (click)="cancel()">
            <i class="fa fa-reply" aria-hidden="true"></i> {{edit ? 'Cancel' : 'Back'}}
          </button>
        </div>
        <div *ngIf="edit" class="col-md-6" style="text-align: right;">
          <button class="btn btn-primary btn-md" (click)="send()" [disabled]="saving || ticket.askedLocation === null || (bulkItems.length === 0 && bulkScraps.length === 0)  || ticket.askedLocation === null || itemsSeleccionados.length === 0">
            <i *ngIf="!saving" class="fa fa-paper-plane" aria-hidden="true"></i>
            <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            Send
          </button>
        </div>
      </div>

    </div>

    <div *ngIf="viendoComentarios">
      <div class="row">
          <div class="col-12">
              <h3> <b> Comments (Item Id: {{editCommentsId}}):</b> </h3> <br>
          </div>
      </div>
      <div class="row">
          <div class="container">
              <div class="row">
                  <div class="col-md-12">
                      <div class="panel panel-primary">
                          <div class="panel-heading" id="accordion">
                          </div>
                          <div class="">
                              <div class="panel-body">
                                  <ul class="chat">
                                      <li *ngFor="let chat of chats"
                                          [ngClass]="[chat['rep']['id'] == this.identity.sub ? 'right' : 'left']"
                                          class="left clearfix"><span class="chat-img "
                                              [ngClass]="[chat['rep']['id'] == this.identity.sub ? 'pull-right' : 'pull-left']">
                                              <img *ngIf="chat['rep']['id'] != this.identity.sub" width="40px"
                                                  style="border-radius: 50px"
                                                  src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{chat['rep']['name'][0]}}{{chat['rep']['surname'][0]}}"
                                                  alt="User Avatar" class="img-circle" />
                                              <img *ngIf="chat['rep']['id'] == this.identity.sub" width="40px"
                                                  style="border-radius: 50px"
                                                  src="https://dummyimage.com/100X100/fa7057/fff.jpg&text={{chat['rep']['name'][0]}}{{chat['rep']['surname'][0]}}"
                                                  alt="User Avatar" class="img-circle" />
                                          </span>
                                          <div class="chat-body clearfix">
                                              <div class="header" style="margin-bottom: 5px">
                                                <small style="margin-left: -60px; float: left" *ngIf="chat['rep']['id'] == this.identity.sub">
                                                  <i style="font-size: 20px; cursor: pointer;" class="material-icons" (click)="deleteChat(chat['id'])">
                                                    delete
                                                  </i>
                                                </small>
                                                  <small style="font-size: .7rem;"
                                                      *ngIf="chat['rep']['id'] == this.identity.sub"
                                                      class="text-muted">
                                                      <i style="font-size: 13px; margin-right: 5px"
                                                          class="material-icons">access_time</i>
                                                      {{chat['createdAt']['timestamp'] * 1000 | date :
                                                      "short" }}
                                                  </small>
                                                  <strong
                                                      [ngClass]="[chat['rep']['id'] == this.identity.sub ? 'pull-right' : '']"
                                                      class=" primary-font">{{chat['rep']['name']}}
                                                      {{chat['rep']['surname']}}</strong> <small
                                                      style="font-size: .7rem;"
                                                      *ngIf="chat['rep']['id'] != this.identity.sub"
                                                      class="pull-right text-muted">
                                                      <i style="font-size: 13px; margin-right: 5px"
                                                          class="material-icons">access_time</i>
                                                      {{chat['createdAt']['timestamp'] * 1000 | date :
                                                      "short" }}</small>
                                              </div>
                                              <p
                                                  [ngClass]="[chat['rep']['id'] == this.identity.sub ? 'text-right' : '']">
                                                  {{chat['message']}}
                                              </p>
                                          </div>
                                      </li>
                                  </ul>
                              </div>
                              <div style="margin-top: 20px" class="panel-footer">
                                  <mat-progress-bar style="width: 80%" *ngIf="loading" id="loadingbar"
                                      mode="indeterminate"></mat-progress-bar>
                                      <app-message-input (sendMessage)="sendMessage($event)"></app-message-input>
                                  <!--<div class="input-group">
                                      <input id="btn-input" name="newchatmsg" [(ngModel)]="newchatmsg"
                                          type="text" class="form-control input-sm"
                                          placeholder="Type your message here..." />
                                      <span class="input-group-btn">
                                          <button (click)="sendChat()" class="btn btn-warning btn-sm"
                                              id="btn-chat">
                                              Send</button>
                                      </span>
                                  </div>-->
                              </div>
                              <div class="row">
                                <div class="col-md-3">
                                  <button class="btn btn-md btn-default" (click)="cancelEditComments()">
                                    <i class="fa fa-reply" aria-hidden="true"></i> Back to List Items
                                  </button>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!--<div class="row">
        <div class="col-md-12">
          <br>
          <h3> <b> Comments (Item Id: {{editCommentsId}}):</b> </h3> <br>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">

          <div class="form-group">
            <label class="bmd-label-floating">Comments:</label>
            <div class="form-group">
              <textarea name="itemComments" #itemComments="ngModel" [(ngModel)]="comentarios" class="form-control"
                rows="5"></textarea>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-3">

          <button class="btn btn-md btn-default" (click)="cancelEditComments()">
            <i class="fa fa-reply" aria-hidden="true"></i> Back to List Items
          </button>

        </div>
        <div class="col-md-3" style="text-align: right;">
          <button class="btn btn-md btn-primary" (click)="updateComments()"
            [disabled]="saingComments">
            <i *ngIf="!saingComments" class="fa fa-pencil-square-o" aria-hidden="true"></i>
            <i *ngIf="saingComments" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            Update Comments
          </button>
        </div>
      </div>-->

    </div>

  </form>

</div>